import React from "react";
import "./whatsappChat.css";

const WhatsAppChat = () => {
  const message = encodeURIComponent(
    "Hello TimBaktu Academy, I would like to learn more about your courses."
  );

  return (
    <a
      className="whatsapp-chat"
      href={`https://wa.me/254713278747?text=${message}`}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat with TimBaktu Academy on WhatsApp"
      title="Chat with us on WhatsApp"
    >
      <i className="fab fa-whatsapp" aria-hidden="true"></i>
      <span>Chat with us</span>
    </a>
  );
};

export default WhatsAppChat;
